@use '@/styles/variables' as *;

// ─── Layout ───────────────────────────────────────────────────────────────────

.about {
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: 5rem;
  align-items: center;
  padding-top: 1rem;
}

// ─── Bio text ─────────────────────────────────────────────────────────────────

.text {
  will-change: transform;
}

.bio {
  font-size: clamp(0.95rem, 1.5vw, 1.05rem);
  color: var(--muted-foreground);
  line-height: 1.85;
  white-space: pre-line;

  & + & {
    margin-top: 1.25rem;
  }

  // Drop cap on the first paragraph
  &:first-child::first-letter {
    font-family: var(--font-display);
    font-size: 3.8em;
    font-weight: 700;
    float: left;
    line-height: 0.82;
    margin-right: 0.06em;
    margin-top: 0.04em;
    color: var(--foreground);
  }
}

// ─── Text highlights ──────────────────────────────────────────────────────────

.highlight {
  background: linear-gradient(135deg, var(--forest), var(--water));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.accent {
  color: var(--primary);
  font-style: italic;
}

// ─── Portrait card ────────────────────────────────────────────────────────────

.cardWrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 6rem;
}

.card {
  width: 100%;
  max-width: 320px;
  aspect-ratio: 3 / 4;
  border-radius: var(--radius);
  border: 1px solid var(--border);
  background: var(--card);
  box-shadow: var(--shadow-soft);
  transform-style: preserve-3d;
  will-change: transform;
  position: relative;
  // overflow must be visible so the portrait can float above the card plane
  overflow: visible;
}

.portrait {
  position: absolute;
  inset: 0.75rem;
  border-radius: calc(var(--radius) - 0.25rem);
  background-color: var(--muted);
  background-image: url('/profile-photo.png');
  background-size: cover;
  background-position: center top;
  transform-style: preserve-3d;
  will-change: transform;
}

.portraitLabel {
  display: none;
}

// ─── Floating chips ───────────────────────────────────────────────────────────

.chips {
  position: absolute;
  top: calc(100% + 1rem);
  left: 50%;
  translate: -50% 0;
  width: 100%;
  max-width: 320px;
  text-align: center;
  line-height: 1.7;
  font-family: ui-monospace, monospace;
  font-size: 0.8rem;
  letter-spacing: 0.07em;
  color: var(--muted-foreground);
  user-select: none;
}

// ─── Responsive ───────────────────────────────────────────────────────────────

@media (max-width: #{$breakpoint-sm}) {
  .about {
    grid-template-columns: 1fr;
    gap: 2.5rem;
  }

  .card {
    max-width: 260px;
  }

  .cardWrapper {
    padding-bottom: 7rem;
  }

  .chips {
    white-space: normal;
    text-align: center;
    width: 100%;
  }

  @supports (animation-timeline: scroll()) {
    @keyframes card-scroll-tilt {
      from {
        transform: perspective(600px) rotateX(20deg);
      }
      to {
        transform: perspective(600px) rotateX(-20deg);
      }
    }

    .card {
      animation: card-scroll-tilt linear both;
      animation-timeline: #{'view()'};
      transition: none;
    }
  }
}

// ─── Reduced motion ───────────────────────────────────────────────────────────

@media (prefers-reduced-motion: reduce) {
  .card,
  .portrait,
  .text {
    will-change: auto;
  }
}
